import React, { useEffect, useState, useRef } from "react";
import './About.css'
import aboutb1ldots1 from './../../../images/aboutb1ldots1.png'
import aboutb1lmatrix from './../../../images/aboutb1lmatrix.png'
import aboutb1rdots1 from './../../../images/aboutb1rdots1.png'
import aboutb1rdots2 from './../../../images/aboutb1rdots2.png'
import aboutb1rmatrix from './../../../images/aboutb1rmatrix.png'
import aboutb2ldots from './../../../images/aboutb2ldots.png'
import aboutb2lmatrix from './../../../images/aboutb2lmatrix.png'
import aboutb2rdots1 from './../../../images/aboutb2rdots1.png'
import aboutb2rdots2 from './../../../images/aboutb2rdots2.png'
import aboutb2rmatrix from './../../../images/aboutb2rmatrix.png'
import aboutb3ldots from './../../../images/aboutb3ldots.png'
import aboutb3nervesign from './../../../images/aboutb3nervesign.png'
import aboutb3rdots from './../../../images/aboutb3rdots.png'
import aboutb4divb from './../../../images/aboutb4divb.png'
import aboutb4divl from './../../../images/aboutb4divl.png'
import aboutstatsimg from './../../../images/aboutstatsimg.png'
import aboutb4divr from './../../../images/aboutb4divr.png'
import aboutb4divt from './../../../images/aboutb4divt.png'
import aboutb4llines from './../../../images/aboutb4llines.png'
import aboutb4rlines from './../../../images/aboutb4rlines.png'
import aboutb5llines from './../../../images/aboutb5llines.png'
import aboutb5rlines from './../../../images/aboutb5rlines.png'
import fugalogo from './../../../images/fugalogo.png'
import lyricvidslogo from './../../../images/lyricvidslogo.png'
import worldcollectionlogo from './../../../images/worldcollectionlogo.png'
import aboutb6llines from './../../../images/aboutb6llines.png'
import aboutb6rlines from './../../../images/aboutb6rlines.png'
import { hover } from "@testing-library/user-event/dist/hover";
import { Link, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { Trans, useTranslation } from 'react-i18next'
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import Footer from "../../Footer/Footer";
import N3rveLogo from './../../../images/N3rveLogo.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";


function About() {
    const [formView, setFormView] = useState(false)
    const [scrollPosition, setScrollPosition] = useState();
    const navigate = useNavigate()
    const cookies = new Cookies(null, { path: '/' });
    const { t, i18n } = useTranslation();
    const [maxScroll, setMaxScroll] = useState(0);
    const parentRef = useRef(null);
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    const hasLogged = useRef(false);

    const handleResize = () => {
        // console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }


    useEffect(() => {
        topFunction()

        const parentHeight = parentRef.current ? parentRef.current.offsetHeight : 0;
        const windowHeight = window.innerHeight;

        // Set the maximum scrollable distance based on the parent div's height
        setMaxScroll(parentHeight - windowHeight);

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "About Page", { "desc": "User opened the about page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "About Page", { "desc": "User opened the about page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "About Page", { "desc": "User opened the about page" })
                hasLogged.current = true;
            }
        }

        window.addEventListener('scroll', handleScroll);
        window.addEventListener("resize", handleResize, false);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    const translateY = scrollPosition > 100 ? Math.min(scrollPosition - 100, maxScroll) : 0;

    return (
        <div>
            {/* ******************************************** */}


            {/* DESKTOP VIEW */}

            {
                dimensions.width >= 1024 &&
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/s87uvi4fgnf3e8y7muod")`,
                        height: '42.5em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        zIndex: '1'
                    }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '11.625em', marginLeft: '9.09%' }}>
                            <div className="AboutH1" style={{ maxWidth: '11.39em', zIndex: '5' }}>
                                We Are bringing Musical innovation Everywhere
                            </div>
                            <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '45.56em' }}>
                                At N3RVE, our mission is to empower artists by providing them with the tools they need to succeed in the digital age. We believe in giving creators control over their music, helping them reach new heights and connect with their audience like never before.
                            </div>
                            <div style={{ marginTop: '1.5em', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ height: '3px', width: '10px', backgroundColor: '#E91353', marginRight: '12px' }} />
                                <div style={{ height: '3px', width: '10px', backgroundColor: '#E91353', marginRight: '12px' }} />
                                <div style={{ height: '3px', width: '44px', backgroundColor: '#E91353', marginRight: '12px' }} />
                            </div>
                        </div>

                        <img src={aboutb1lmatrix} style={{ width: '21.87em', height: '8.75em', position: 'absolute', bottom: '0em', left: '0em', zIndex: '3' }} />
                        <img src={aboutb1rmatrix} style={{ width: '21.87em', height: '14.625em', position: 'absolute', bottom: '0em', right: '0em', zIndex: '3' }} />
                        {/* <img src={aboutb1ldots1} style={{width:'9.65em',height:'40.94em',position:'absolute',left:'0em',zIndex:'2'}}/> */}
                        <img src={aboutb1rmatrix} style={{ width: '21.87em', height: '14.625em', position: 'absolute', bottom: '0em', right: '0em' }} />
                        <img src={aboutb1rdots1} style={{ width: '3.98em', height: '15.75em', position: 'absolute', top: '0em', right: '0em' }} />
                        <img src={aboutb1rdots2} style={{ width: '3.98em', height: '15.75em', position: 'absolute', bottom: '0em', right: '0em', zIndex: '2' }} />
                    </div>

                    <div style={{
                        backgroundColor: '#0E1419',
                        height: '38em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        alignItems: 'center',
                        zIndex: '1'
                    }}
                    >

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: '5.06em',
                            width: '90%',
                            justifyContent: 'center'
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: '-13em', zIndex: '3', position: 'relative' }}>
                                <div className="AboutH2">A N3RVE family company</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '33.875em' }}>Founded by a team of music enthusiasts and tech innovators, N3RVE is dedicated to transforming the music industry. We combine cutting-edge technology with a passion for music to deliver unparalleled services to artists worldwide.</div>
                                {/* <img src={aboutb2ldots} style={{width:'11.16em',height:'20.79em',position:'absolute',bottom:'-6.7em',left:'-11.625em',zIndex:'1'}}/> */}
                            </div>

                            <div style={{ position: 'relative' }}>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/vwnb7qrlizmmyjpg9jva"} style={{ zIndex: '2' }} />
                                <img src={aboutb2rdots1} style={{ width: '6.04em', height: '0.54em', position: 'absolute', top: '1.5em', right: '-4em', zIndex: '1' }} />
                                <img src={aboutb2rdots2} style={{ width: '7.25em', height: '24.69em', position: 'absolute', top: '5em', right: '-10em', zIndex: '1' }} />
                            </div>
                        </div>

                        <img src={aboutb2lmatrix} style={{ width: '8.75em', height: '8.75em', position: 'absolute', top: '0em', left: '0em', zIndex: '1' }} />
                        <img src={aboutb2rmatrix} style={{ width: '8.75em', height: '8.75em', position: 'absolute', top: '0em', right: '0em', zIndex: '1' }} />


                    </div>

                    <div style={{
                        backgroundColor: '#000000',
                        height: '67.68em',
                        width: '100%',
                        backgroundSize: '150%',
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'relative',
                        backgroundPosition: 'center',
                        zIndex: '1'
                    }}
                    >

                        <div
                            ref={parentRef}
                            style={{
                                backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/bjsuwc8hxfhujc7anzwv")`,
                                height: '100%',
                                width: '40%',
                                backgroundSize: 'cover',
                                display: 'flex',
                                flexDirection: 'column',
                                zIndex: '1',
                                position: 'relative',
                                overflow: 'hidden',
                                paddingLeft: '2em'
                            }}
                        >

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2em' }}>
                                <span className="AboutH2" style={{ color: '#7199FF' }}>15<span style={{ color: '#FFFFFF' }}>+</span></span>
                                <div className="AboutH25" style={{ color: '#FFFFFF', maxWidth: '7.5em', marginTop: '0.6em' }}>Locations across the globe</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1em', marginTop: '4em' }}>
                                <span className="AboutH2" style={{ color: '#7199FF' }}>170<span style={{ color: '#FFFFFF' }}>+</span></span>
                                <div className="AboutH25" style={{ color: '#FFFFFF', maxWidth: '7.5em', marginTop: '0.6em' }}>team members</div>
                            </div>

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '65%', position: 'relative' }}>
                            <img src={aboutstatsimg} style={{ width: '100%', marginTop: '2em', maxHeight: '25em', maxWidth: '45em' }} />


                            <div style={{ width: '1px', height: '100%', backgroundColor: '#333333', position: 'absolute', right: '5%' }} />

                            <div style={{ width: '95%', height: '1px', backgroundColor: '#333333', marginTop: '2em', marginRight: '5%' }} />

                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', height: '33%' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '50%', borderRight: '1px solid #333333', paddingTop: '2em', paddingBottom: '2em' }}>
                                    <div className="AboutH27">Our Core Values</div>
                                    <div className="AboutH4" style={{ marginTop: '2em', maxWidth: '22em' }}>The Foundation.</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', width: '50%', borderRight: '1px solid #333333', paddingLeft: '2em', paddingTop: '2em', paddingBottom: '2em' }}>
                                    <div className="AboutH27">Be Honest</div>
                                    <div className="AboutH4" style={{ marginTop: '2em', maxWidth: '22em' }}>We are only as valuable as the word we give to others.</div>
                                </div>
                            </div>

                            <div style={{ width: '95%', height: '1px', backgroundColor: '#333333', marginRight: '5%' }} />

                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', height: '33%' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '50%', borderRight: '1px solid #333333', paddingTop: '2em', paddingBottom: '2em' }}>
                                    <div className="AboutH27">Work</div>
                                    <div className="AboutH4" style={{ marginTop: '2em', maxWidth: '22em' }}>Work Hard, Work Smart.</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', width: '50%', borderRight: '1px solid #333333', paddingLeft: '2em', paddingTop: '2em', paddingBottom: '2em' }}>
                                    <div className="AboutH27">Community</div>
                                    <div className="AboutH4" style={{ marginTop: '2em', maxWidth: '22em' }}>Always give back to those who support you.</div>
                                </div>
                            </div>

                            <div style={{ width: '95%', height: '1px', backgroundColor: '#333333', marginRight: '5%' }} />

                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', height: '33%' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '50%', borderRight: '1px solid #333333', paddingTop: '2em', paddingBottom: '2em' }}>
                                    <div className="AboutH27">Vision</div>
                                    <div className="AboutH4" style={{ marginTop: '2em', maxWidth: '22em' }}>Make your vision a reality. Do not settle on the judgement of others.</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', width: '50%', borderRight: '1px solid #333333', paddingLeft: '2em', paddingTop: '2em', paddingBottom: '2em' }}>
                                    <div className="AboutH27">Be Passionate</div>
                                    <div className="AboutH4" style={{ marginTop: '2em', maxWidth: '22em' }}>Be Bold, Be Creative, Be Loud.</div>
                                </div>
                            </div>

                        </div>
                        {/* <img src={aboutb3nervesign}  style={{position:'absolute'}}/> */}
                        {/* <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'7.5em'}}>
                        <div className="AboutH1" style={{color:'#6D33C9'}}>15+</div>
                        <div className="AboutH3" style={{color:'#131317'}}>locations across the globe</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                         <div className="AboutH1" style={{color:'#6D33C9'}}>170+</div>
                         <div className="AboutH3" style={{color:'#131317'}}>team members</div>
                    </div>  

                     <img src={aboutb3ldots} style={{width:'13.85em',height:'16.01em',position:'absolute',top:'1em',left:'1em',zIndex:'1'}}/>
                     <img src={aboutb3rdots} style={{width:'13.85em',height:'16.01em',position:'absolute',top:'1em',right:'1em',zIndex:'1'}}/> */}
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/v7hc6s9iei2ngy4z8e17")`,
                        height: '38em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        overflow: 'hidden',
                        zIndex: '1'
                    }}
                    >

                        <div style={{ backgroundColor: 'rgba(0,0,0,45%)', padding: '5.68em 6em 5.68em 6em', position: 'relative', zIndex: '3' }}>
                            <div className="AboutH2" style={{ color: '#C7A5FF' }}>How we started</div>
                            <div className="AboutH4" style={{ marginTop: '0.67em', maxWidth: '27.75em' }}>Launched in 2022, N3RVE is a collective of leaders within entertainment, fashion, finance, and digital industries.  We work in unison with one another to promote, help and protect the interests of our clients, and push the boundaries of culture.</div>
                            <img src={aboutb4divb} style={{ width: '51.93em', height: '0.68em', position: 'absolute', bottom: '-0.7em', right: '-19em', zIndex: '1' }} />
                            <img src={aboutb4divl} style={{ width: '1px', height: '38.18em', position: 'absolute', bottom: '-3em', left: '0em', zIndex: '1' }} />
                            <img src={aboutb4divt} style={{ width: '52.31em', height: '0.31em', position: 'absolute', left: '-30em', top: '-0.4em', zIndex: '1' }} />
                            <img src={aboutb4divr} style={{ width: '0.68em', height: '22.875em', position: 'absolute', right: '-0.8em', top: '-2em', zIndex: '1' }} />
                        </div>

                        <img src={aboutb4llines} style={{ width: '6.65em', height: '46.399em', position: 'absolute', left: '2em', top: '0em', zIndex: '1' }} />
                        <img src={aboutb4rlines} style={{ width: '6.65em', height: '46.399em', position: 'absolute', right: '4em', top: '0em', zIndex: '1' }} />
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        backgroundImage: 'linear-gradient(216deg, rgba(20,19,27,1) 0%, rgba(24,23,31,1) 49%, rgba(127,70,132,1) 100%)',
                        height: '45em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'relative',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        overflow: 'hidden',
                        zIndex: '1'
                    }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', zIndex: '3', justifyContent: 'center', alignItems: 'center' }}>
                                <div className="AboutH2" style={{ marginBottom: '0.5em', textAlign: 'center' }}>Our Partners</div>
                                <div className="AboutH4" style={{ maxWidth: '60%', textAlign: 'center' }}>We pair innovative technology with high-touch service by genuine industry experts, and is customized to each rights holder’s unique needs.  This hybrid approach allows for more thorough detections throughout UGC platforms, fewer false claims, and reliably higher returns to creators. </div>
                            </div>

                            <img src={N3rveLogo} style={{ width: '9.18em', height: '1.62em', marginTop: '4.99em' }} />

                            <div style={{ width: '1px', height: '2.5em', marginTop: '1.5em', marginBottom: '1.5em', backgroundColor: 'rgba(255,255,255,60%)' }} />

                            <div style={{ display: 'flex', flexDirection: 'row', zIndex: '3', backgroundColor: 'rgba(255,255,255,5%)', width: '100%', alignItems: 'center', justifyContent: 'center', height: '11.06em' }}>
                                <div className="partnerCard" style={{ height: '100%', paddingLeft: '1.7em', paddingRight: '1.7em', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href="https://fuga.com/" target="_blank"><img src={fugalogo} style={{ width: '11.09em', height: '2.5em', cursor: 'pointer' }} /></a>'
                                </div>
                                <div className="partnerCard" style={{ height: '100%', paddingLeft: '1.7em', paddingRight: '1.7em', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href="/worldcollection" target="_blank"><img src={worldcollectionlogo} style={{ width: '11.09em', height: '1.5em', cursor: 'pointer' }} /></a>
                                </div>
                                <div className="partnerCard" style={{ height: '100%', paddingLeft: '1.7em', paddingRight: '1.7em', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={lyricvidslogo} style={{ width: '11.25em', height: '1.95em', cursor: 'pointer' }} />
                                </div>
                            </div>

                            <img src={aboutb5llines} style={{ width: '8.95em', height: '35.25em', left: '1em', top: '0em', position: 'absolute', zIndex: '2' }} />
                            <img src={aboutb5rlines} style={{ width: '7.16em', height: '32.45em', right: '2em', top: '0em', position: 'absolute', zIndex: '2' }} />
                        </div>
                    </div>

                    {/* <div style={{ 
                    backgroundColor:'#DFDFDE', 
                    backgroundImage:`url(${aboutbanner6})`,
                     height:'37.5em',
                     width:'100%',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     position:'relative',
                     justifyContent:'center',
                     backgroundPosition:'center',
                     backgroundRepeat:'no-repeat',
                     overflow:'hidden',
                     zIndex:'1'
                   }}
                   >
                      <img src={aboutb6llines} style={{width:'0.625em',height:'30.31em',left:'1.5em',position:'absolute',zIndex:'2'}}/>
                    <img src={aboutb6rlines} style={{width:'5.26em',height:'40.07em',right:'0em',position:'absolute',zIndex:'2'}}/>

                     <div style={{display:'flex',flexDirection:'column',marginLeft:'50%',zIndex:'3'}}>
                     <div className="AboutH2" style={{marginBottom:'0.67em',maxWidth:'10em'}}>Musical Freedom Begins Here</div>
                     <div className="AboutH4" style={{maxWidth:'26.67em'}}>No more restrictive contracts, no more outside interference, just pure music creation and distribution in its rawest form.</div>
                     <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'30.93em',height:'4em',  marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}  onClick={()=>{navigate("/Signup");cookies.set('btnclick', "landingjoin2");}}>
                       <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                       <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                       <div className="TestLarge">
                         {t('Joinus')}
                         <div className="HoverOverlay" />
                       </div>
                     </div>
                     </div>
                   </div> */}

                    <Footer />
                </div>
            }



            {/* ******************************************** */}


            {/* TABLET AND MOBILE VIEW */}

            {
                dimensions.width < 1024 &&
                <div style={{ display: 'flex', flexDirection: 'column', overlay: 'hidden' }}>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/s87uvi4fgnf3e8y7muod")`,
                        //  height:'49.5em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        zIndex: '1',
                        paddingBottom: '4em'
                    }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '11.625em', marginLeft: '3.09%', zIndex: '4' }}>
                            <div className="AboutH1" style={{ maxWidth: '11.39em', zIndex: '5' }}>
                                We Are bringing Musical innovation Everywhere
                            </div>
                            <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '80%' }}>
                                At N3RVE, our mission is to empower artists by providing them with the tools they need to succeed in the digital age. We believe in giving creators control over their music, helping them reach new heights and connect with their audience like never before.
                            </div>
                            <div style={{ marginTop: '1.5em', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ height: '3px', width: '10px', backgroundColor: '#E91353', marginRight: '12px' }} />
                                <div style={{ height: '3px', width: '10px', backgroundColor: '#E91353', marginRight: '12px' }} />
                                <div style={{ height: '3px', width: '44px', backgroundColor: '#E91353', marginRight: '12px' }} />
                            </div>
                        </div>

                        <img src={aboutb1lmatrix} style={{ width: '21.87em', height: '8.75em', position: 'absolute', bottom: '0em', left: '0em', zIndex: '3' }} />
                        <img src={aboutb1rmatrix} style={{ width: '21.87em', height: '14.625em', position: 'absolute', bottom: '0em', right: '0em', zIndex: '3' }} />
                        {/* <img src={aboutb1ldots1} style={{width:'9.65em',height:'40.94em',position:'absolute',left:'0em',zIndex:'2'}}/> */}
                        <img src={aboutb1rmatrix} style={{ width: '21.87em', height: '14.625em', position: 'absolute', bottom: '0em', right: '0em' }} />
                        {/* <img src={aboutb1rdots1} style={{width:'3.98em',height:'15.75em',position:'absolute',top:'0em',right:'0em'}}/>
                <img src={aboutb1rdots2} style={{width:'3.98em',height:'15.75em',position:'absolute',bottom:'0em',right:'0em',zIndex:'2'}}/> */}
                    </div>

                    <div style={{
                        // backgroundColor:'#0E1419', 
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/vwnb7qrlizmmyjpg9jva")`,
                        height: '40em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        alignItems: 'center',
                        zIndex: '1'
                    }}
                    >

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: '5.06em',
                            width: '90%',
                            justifyContent: 'center',
                            marginLeft: '9.09%'
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column', zIndex: '3', position: 'relative', maxWidth: '100%' }}>
                                <div className="AboutH2">A N3RVE family company</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '100%' }}>Founded by a team of music enthusiasts and tech innovators, N3RVE is dedicated to transforming the music industry. We combine cutting-edge technology with a passion for music to deliver unparalleled services to artists worldwide.</div>
                                <img src={aboutb2ldots} style={{ width: '11.16em', height: '20.79em', position: 'absolute', bottom: '-6.7em', left: '-11.625em', zIndex: '1' }} />
                            </div>

                            {/* <div style={{position:'relative'}}> */}
                            {/* <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/vwnb7qrlizmmyjpg9jva"} style={{zIndex:'2'}}/> */}
                            {/* <img src={aboutb2rdots1} style={{width:'6.04em',height:'0.54em',position:'absolute',top:'1.5em',right:'-4em',zIndex:'1'}}/>
                    <img src={aboutb2rdots2} style={{width:'7.25em',height:'24.69em',position:'absolute',top:'5em',right:'-10em',zIndex:'1'}}/> */}
                            {/* </div> */}
                        </div>

                        <img src={aboutb2lmatrix} style={{ width: '8.75em', height: '8.75em', position: 'absolute', top: '0em', left: '0em', zIndex: '1' }} />
                        <img src={aboutb2rmatrix} style={{ width: '8.75em', height: '8.75em', position: 'absolute', top: '0em', right: '0em', zIndex: '1' }} />


                    </div>

                    <div style={{
                        backgroundColor: '#000000',
                        height: '105em',
                        width: '100%',
                        backgroundSize: '150%',
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'relative',
                        backgroundPosition: 'center',
                        zIndex: '1'
                    }}
                    >

                        <div
                            ref={parentRef}
                            style={{
                                backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/bjsuwc8hxfhujc7anzwv")`,
                                height: '100%',
                                width: '100%',
                                backgroundSize: 'cover',
                                display: 'flex',
                                flexDirection: 'column',
                                zIndex: '1',
                                position: 'relative',
                                overflow: 'hidden',
                                paddingLeft: '2em'
                            }}
                        >
                            <div style={{ width: '1px', height: '100%', backgroundColor: '#333333', position: 'absolute', right: '10%' }} />
                            <div style={{ width: '1px', height: '100%', backgroundColor: '#333333', position: 'absolute', left: '2%' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2em' }}>
                                <span className="AboutH2" style={{ color: '#7199FF' }}>15<span style={{ color: '#FFFFFF' }}>+</span></span>
                                <div className="AboutH25" style={{ color: '#FFFFFF', maxWidth: '80%', marginTop: '0.6em' }}>Locations across the globe</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1em', marginTop: '4em' }}>
                                <span className="AboutH2" style={{ color: '#7199FF' }}>170<span style={{ color: '#FFFFFF' }}>+</span></span>
                                <div className="AboutH25" style={{ color: '#FFFFFF', maxWidth: '80%', marginTop: '0.6em' }}>team members</div>
                            </div>

                            <img src={aboutstatsimg} style={{ width: '90%', marginTop: '2em', maxHeight: '20em', maxWidth: '40em' }} />



                            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingTop: '2em', paddingBottom: '2em', position: 'relative' }}>
                                <div style={{ width: '103%', height: '1px', backgroundColor: '#333333', right: '0.5em', top: '-1%', position: 'absolute' }} />
                                <div className="AboutH27">Our Core Values</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '22em' }}>The Foundation.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingTop: '2em', paddingBottom: '2em', position: 'relative' }}>
                                <div style={{ width: '103%', height: '1px', backgroundColor: '#333333', right: '0.5em', top: '-1%', position: 'absolute' }} />
                                <div className="AboutH27">Be Honest</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '22em' }}>We are only as valuable as the word we give to others.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingTop: '2em', paddingBottom: '2em', position: 'relative' }}>
                                <div style={{ width: '103%', height: '1px', backgroundColor: '#333333', right: '0.5em', top: '-1%', position: 'absolute' }} />
                                <div className="AboutH27">Work</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '22em' }}>Work Hard, Work Smart.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingTop: '2em', paddingBottom: '2em', position: 'relative' }}>
                                <div style={{ width: '103%', height: '1px', backgroundColor: '#333333', right: '0.5em', top: '-1%', position: 'absolute' }} />
                                <div className="AboutH27">Community</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '22em' }}>Always give back to those who support you.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingTop: '2em', paddingBottom: '2em', position: 'relative' }}>
                                <div style={{ width: '103%', height: '1px', backgroundColor: '#333333', right: '0.5em', top: '-1%', position: 'absolute' }} />
                                <div className="AboutH27">Vision</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '22em' }}>Make your vision a reality. Do not settle on the judgement of others.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingTop: '2em', paddingBottom: '2em', position: 'relative' }}>
                                <div style={{ width: '103%', height: '1px', backgroundColor: '#333333', right: '0.5em', top: '-1%', position: 'absolute' }} />
                                <div className="AboutH27">Be Passionate</div>
                                <div className="AboutH4" style={{ marginTop: '1em', maxWidth: '22em' }}>Be Bold, Be Creative, Be Loud.</div>
                            </div>


                        </div>

                        {/* <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'65%',position:'relative'}}>
                   


                      <div style={{width:'1px',height:'100%',backgroundColor:'#333333',position:'absolute',right:'5%'}}/>

                      <div style={{width:'95%',height:'1px',backgroundColor:'#333333',marginTop:'2em',marginRight:'5%'}}/>
                      
                      
                         

                      <div style={{width:'95%',height:'1px',backgroundColor:'#333333',marginRight:'5%'}}/>

                     
                         

                      <div style={{width:'95%',height:'1px',backgroundColor:'#333333',marginRight:'5%'}}/>

                      
                         

                    </div> */}
                        {/* <img src={aboutb3nervesign}  style={{position:'absolute'}}/> */}
                        {/* <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'7.5em'}}>
                        <div className="AboutH1" style={{color:'#6D33C9'}}>15+</div>
                        <div className="AboutH3" style={{color:'#131317'}}>locations across the globe</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                         <div className="AboutH1" style={{color:'#6D33C9'}}>170+</div>
                         <div className="AboutH3" style={{color:'#131317'}}>team members</div>
                    </div>  

                     <img src={aboutb3ldots} style={{width:'13.85em',height:'16.01em',position:'absolute',top:'1em',left:'1em',zIndex:'1'}}/>
                     <img src={aboutb3rdots} style={{width:'13.85em',height:'16.01em',position:'absolute',top:'1em',right:'1em',zIndex:'1'}}/> */}
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/v7hc6s9iei2ngy4z8e17")`,
                        height: '38em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        overflow: 'hidden',
                        zIndex: '1'
                    }}
                    >

                        <div style={{ backgroundColor: 'rgba(0,0,0,45%)', padding: '5.68em 6em 5.68em 6em', position: 'relative', zIndex: '3' }}>
                            <div className="AboutH2" style={{ color: '#C7A5FF' }}>How we started</div>
                            <div className="AboutH4" style={{ marginTop: '0.67em', maxWidth: '27.75em' }}>Launched in 2022, N3RVE is a collective of leaders within entertainment, fashion, finance, and digital industries.  We work in unison with one another to promote, help and protect the interests of our clients, and push the boundaries of culture.</div>
                            <img src={aboutb4divb} style={{ width: '51.93em', height: '0.68em', position: 'absolute', bottom: '-0.7em', right: '-19em', zIndex: '1' }} />
                            <img src={aboutb4divl} style={{ width: '1px', height: '38.18em', position: 'absolute', bottom: '-3em', left: '0em', zIndex: '1' }} />
                            <img src={aboutb4divt} style={{ width: '52.31em', height: '0.31em', position: 'absolute', left: '-30em', top: '-0.4em', zIndex: '1' }} />
                            <img src={aboutb4divr} style={{ width: '0.68em', height: '22.875em', position: 'absolute', right: '-0.8em', top: '-2em', zIndex: '1' }} />
                        </div>

                        <img src={aboutb4llines} style={{ width: '6.65em', height: '46.399em', position: 'absolute', left: '2em', top: '0em', zIndex: '1' }} />
                        <img src={aboutb4rlines} style={{ width: '6.65em', height: '46.399em', position: 'absolute', right: '4em', top: '0em', zIndex: '1' }} />
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        backgroundImage: 'linear-gradient(216deg, rgba(20,19,27,1) 0%, rgba(24,23,31,1) 49%, rgba(127,70,132,1) 100%)',
                        height: '55em',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'relative',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        overflow: 'hidden',
                        zIndex: '1'
                    }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', zIndex: '3', justifyContent: 'center', alignItems: 'center', marginTop: '1.5em' }}>
                                <div className="AboutH2" style={{ marginBottom: '0.5em', textAlign: 'center' }}>Our Partners</div>
                                <div className="AboutH4" style={{ maxWidth: '60%', textAlign: 'center' }}>We pair innovative technology with high-touch service by genuine industry experts, and is customized to each rights holder’s unique needs.  This hybrid approach allows for more thorough detections throughout UGC platforms, fewer false claims, and reliably higher returns to creators. </div>
                            </div>

                            <img src={N3rveLogo} style={{ width: '9.18em', height: '1.62em', marginTop: '4.99em' }} />

                            <div style={{ width: '1px', height: '2.5em', marginTop: '1.5em', marginBottom: '1.5em', backgroundColor: 'rgba(255,255,255,60%)' }} />

                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', zIndex: '3', backgroundColor: 'rgba(255,255,255,5%)', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                <div className="partnerCard" style={{ paddingTop: '4.28em', paddingBottom: '4.28em', paddingLeft: '1.7em', paddingRight: '1.7em', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <a href="https://fuga.com/" target="_blank"><img src={fugalogo} style={{ width: '11.09em', height: '2.5em', cursor: 'pointer' }} /></a>
                                </div>
                                <div className="partnerCard" style={{ paddingTop: '4.28em', paddingBottom: '4.28em', paddingLeft: '1.7em', paddingRight: '1.7em' }}>
                                    <a href="/worldcollection" target="_blank"><img src={worldcollectionlogo} style={{ width: '11.09em', height: '1.5em', cursor: 'pointer' }} /></a>
                                </div>
                                <div className="partnerCard" style={{ paddingTop: '4.28em', paddingBottom: '4.28em', paddingLeft: '1.7em', paddingRight: '1.7em' }}>
                                    <img src={lyricvidslogo} style={{ width: '11.25em', height: '1.95em', cursor: 'pointer' }} />
                                </div>
                            </div>

                            <img src={aboutb5llines} style={{ width: '8.95em', height: '35.25em', left: '1em', top: '0em', position: 'absolute', zIndex: '2' }} />
                            <img src={aboutb5rlines} style={{ width: '7.16em', height: '32.45em', right: '2em', top: '0em', position: 'absolute', zIndex: '2' }} />
                        </div>
                    </div>

                    {/* <div style={{ 
                    backgroundColor:'#DFDFDE', 
                    backgroundImage:`url(${aboutbanner6})`,
                     height:'37.5em',
                     width:'100%',
                     backgroundSize:'cover',
                     display:'flex',
                     flexDirection:'column',
                     position:'relative',
                     justifyContent:'center',
                     backgroundPosition:'center',
                     backgroundRepeat:'no-repeat',
                     overflow:'hidden',
                     zIndex:'1'
                   }}
                   >
                      <img src={aboutb6llines} style={{width:'0.625em',height:'30.31em',left:'1.5em',position:'absolute',zIndex:'2'}}/>
                    <img src={aboutb6rlines} style={{width:'5.26em',height:'40.07em',right:'0em',position:'absolute',zIndex:'2'}}/>

                     <div style={{display:'flex',flexDirection:'column',marginLeft:'50%',zIndex:'3'}}>
                     <div className="AboutH2" style={{marginBottom:'0.67em',maxWidth:'10em'}}>Musical Freedom Begins Here</div>
                     <div className="AboutH4" style={{maxWidth:'26.67em'}}>No more restrictive contracts, no more outside interference, just pure music creation and distribution in its rawest form.</div>
                     <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'30.93em',height:'4em',  marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}  onClick={()=>{navigate("/Signup");cookies.set('btnclick', "landingjoin2");}}>
                       <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                       <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                       <div className="TestLarge">
                         {t('Joinus')}
                         <div className="HoverOverlay" />
                       </div>
                     </div>
                     </div>
                   </div> */}

                    <Footer />
                </div>
            }


        </div>
    );
}

export default About;